import { g as getRoomType } from './get-room-type.js';
import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * **Hotel Agent**
 *
 * @exports bs_465
 * @category engines
 */
const factory = function factory({ window, document, thn }) {
    const roomDetailsParseData = (numAdults, numChildren, nights) => {
        const roomsArray = Array.from(document.querySelectorAll('.MuiStack-root.css-9e36vm'));
        if (thn.empty(roomsArray)) {
            return [];
        }
        const roomsInfo = roomsArray.map((room) => {
            const roomName = room.querySelector('p.MuiTypography-root.MuiTypography-body1')?.textContent?.trim();
            const roomType = getRoomType(roomName);
            const ratesInfo = Array.from(room.querySelectorAll('.MuiBox-root.css-34jg5i')).map((rate) => {
                const rateName = '';
                const ratePrice = thn.parseNumber(rate?.querySelector('.MuiTypography-root.MuiTypography-body1.css-kc4c85')?.textContent);
                const hasBreakfast = true;
                const isRefundable = !!rate.querySelector('span.MuiTypography-root.MuiTypography-body1.css-5xu71o')?.textContent?.match(/Free cancellation|ücretsiz iptal/i);
                if (!ratePrice) {
                    return null;
                }
                const rateData = {
                    name: rateName,
                    totalNight: ratePrice / nights,
                    breakfast: hasBreakfast,
                    refundable: isRefundable,
                };
                return rateData;
            }).filter((value) => value !== null);
            if (!roomName) {
                return null;
            }
            return {
                name: roomName,
                adults: numAdults || 2,
                children: numChildren || 0,
                type: roomType,
                prices: ratesInfo,
            };
        });
        return roomsInfo.filter((value) => value !== null);
    };
    return {
        onStateChange: thn.debounce(() => {
            thn.widgets.price.refresh().catch(() => { });
            thn.pageCheck();
        }, 700),
        priceParseData() {
            // Guests, Adults & Children
            const adults = thn.parseNumber(thn.parseUrlParameter('adult_1')) || 2;
            const children = thn.parseNumber(thn.parseUrlParameter('child_1')) || 0;
            const roomsDispo = [];
            // Children Ages
            const childrenAges = [];
            for (let i = 0; i < children; i += 1) {
                const age = thn.parseNumber(thn.parseUrlParameter(`childage_1_${i + 1}`)) || 10;
                childrenAges.push(age);
            }
            const roomData = {
                adults,
                children,
                childrenAges,
            };
            roomsDispo.push(roomData);
            // Dates
            const dateBegin = thn.parseUrlParameter('checkIn')?.replace(/-/g, '/');
            const dateEnd = thn.parseUrlParameter('checkOut')?.replace(/-/g, '/');
            if (!dateBegin || !dateEnd) {
                return null;
            }
            const nights = thn.daysBetween(dateBegin, dateEnd) ?? 0;
            // Prices & Currency || No Rooms
            const pricesEls = Array.from(document.querySelectorAll('.MuiTypography-root.MuiTypography-body1.css-kc4c85'));
            const prices = pricesEls.map((price) => thn.parseNumber(price.textContent)).filter((value) => value !== undefined);
            const currency = thn.parseCurrency(pricesEls?.[0]?.textContent);
            if (!thn.empty(prices) && currency) {
                return {
                    roomsDispo,
                    dateBegin,
                    dateEnd,
                    roomDetails: roomDetailsParseData(adults, children, nights),
                    price: Math.min(...prices) / nights,
                    currency,
                };
            }
            if (thn.empty(prices)) {
                return {
                    adults,
                    children,
                    currency,
                    dateBegin,
                    dateEnd,
                    noRooms: true,
                };
            }
            return null;
        },
        bookingParseData() {
            // Booking ID
            const bookingIdFromDom = document.querySelector('#successMain .reservation-number')?.textContent?.trim() || thn.parseNumber(document.querySelector('.MuiStack-root > p:nth-child(2)')?.textContent);
            const bookingId = bookingIdFromDom?.toString();
            if (!bookingId) {
                return {
                    set: false,
                };
            }
            // Dates
            const datesTextArray = document.querySelector('.fa-calendar')?.nextElementSibling?.textContent?.split('-');
            const dateBegin = translateDate(document.querySelector('#successMain .checkInOut-Success > div.date-box:first-child .date')?.textContent?.trim() || datesTextArray?.[0] || '');
            const dateEnd = translateDate(document.querySelector('#successMain .checkInOut-Success > div.date-box:nth-child(2) .date')?.textContent?.trim() || datesTextArray?.[1] || '');
            // Price & Currency
            const textElements = Array.from(document.querySelectorAll('.MuiTypography-root'));
            const priceAndCurrency = document.querySelector('#successMain .payment-price-amount')?.textContent?.trim() || textElements[textElements.length - 1]?.textContent;
            const price = thn.parseNumber(priceAndCurrency);
            const currency = thn.parseCurrency(priceAndCurrency);
            const data = {
                bookingId,
                dateBegin,
                dateEnd,
                price,
                currency,
            };
            return data;
        },
    };
};

export { factory };
